import React from 'react';

export const ListingsIcon = props => (
  <svg viewBox="0 0 18 21" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g stroke="#FFF" fill="none" fillRule="evenodd" strokeLinejoin="round">
      <path d="M15.4694215 18.1534139H3.06281173M13.4859468 19.933133H5.04628281M1.41322314 16.3831705H17.1157025V1.39444027H1.41322314z" />
      <path d="M15.0495868 13.2276484l-2.4793389-6.31104434-3.30578509 4.73328324-2.0661157-2.36664162-2.47933885 3.94440272M5.95867769 3.76108227c.68512396 0 1.23966942.52933884 1.23966942 1.18332081 0 .65398197-.55454546 1.18332081-1.23966942 1.18332081-.68512397 0-1.23966943-.52933884-1.23966943-1.18332081 0-.65398197.55454546-1.18332081 1.23966943-1.18332081zM17.1157025 13.22764876H1.41322314" />
    </g>
  </svg>
);
